<div class="min-h-screen bg-slate-50 font-sans text-slate-800 flex flex-col">
  <!-- NAVIGATION -->
  <app-navigation [currentUser]="currentUser" (navigate)="navigate($event)" (openAuth)="openAuthModal($event)"
    (logout)="logout()">
  </app-navigation>

  <!-- MAIN CONTENT AREA — pages injected via router -->
  <main class="fade-in flex-grow">
    <router-outlet></router-outlet>
  </main>

  <!-- FOOTER -->
  <app-footer></app-footer>

  <!-- AUTH MODAL -->
  <app-auth-modal [show]="showAuthModal" [mode]="authMode" (close)="closeAuthModal()" (success)="onAuthSuccess()"
    (openPayment)="onAuthPaymentRequest($event)">
  </app-auth-modal>

  <!-- PAYMENT MODAL -->
  <app-payment-modal [show]="showPaymentModal"
    [paymentType]="selectedEvent && ((selectedEvent.pricingType === 'PAID' || selectedEvent.pricingType === 'DISCOUNTED') || (selectedEvent.memberPrice && selectedEvent.memberPrice > 0) || (selectedEvent.nonMemberPrice && selectedEvent.nonMemberPrice > 0) || (selectedEvent.price && selectedEvent.price > 0)) ? 'EVENT' : 'MEMBERSHIP'"
    [event]="selectedEvent" [planData]="paymentPlanData" [quantity]="selectedEvent?.quantity || 1" (close)="closePaymentModal()"
    (success)="onPaymentSuccess($event)">
  </app-payment-modal>

  <!-- EVENT DETAIL / BOOKING MODAL -->
  <app-event-detail-modal [show]="showEventDetailModal" [event]="selectedEvent" (close)="closeEventDetailModal()"
    (registered)="onEventRegistered()" (openPayment)="onEventPaymentRequest($event)">
  </app-event-detail-modal>

  <!-- GLOBAL NOTIFICATIONS AND CONFIRMATIONS -->
  <app-toast></app-toast>
  <app-confirm-modal></app-confirm-modal>
</div>